import { render, staticRenderFns } from "./NoMessages.vue?vue&type=template&id=3e210dca&"
import script from "./NoMessages.vue?vue&type=script&lang=js&"
export * from "./NoMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports